// extracted by mini-css-extract-plugin
export var button = "_du-7";
export var buttonRow = "_du-6";
export var fadeIn = "_du-1";
export var gradient = "_du-0";
export var panel = "_du-2";
export var panelIn = "_du-3";
export var subtitle = "_du-5";
export var title = "_du-4";